<div class="container statistics">
  <div class="row statistics__row">

    <!-- Department stats -->
    <div class="col-md-6 col-lg-3 statistics__col">
      <app-skeleton-loader
        *ngIf="isLoading; else departmentStats"
      ></app-skeleton-loader>

      <ng-template #departmentStats>
        <app-statistics-card
          [statsSVG]="((utilSerivce.themeCheck | async) === 'dark' ? departmentCountDarkSVG : departmentCountSVG) | safeHTML"
          statsType="departments"
          [allStatistics]="allStatistics"
          ><span
            app-animating-count
            [count]="+allStatistics?.totalDept"
            [yOffset]="-200"
            [skips]="5"
            [interval]="40"
          ></span>
          {{ "stats.departmentsEntities" | translate }}</app-statistics-card
        >
      </ng-template>
    </div>
    <!-- Service stats -->
    <div class="col-md-6 col-lg-3 statistics__col">
      <app-skeleton-loader
        *ngIf="isLoading; else serviceStats"
      ></app-skeleton-loader>

      <ng-template #serviceStats>
        <app-statistics-card
          [statsSVG]="((utilSerivce.themeCheck | async) === 'dark' ? serviceCountDarkSVG : serviceCountSVG) | safeHTML"
          statsType="services"
          [allStatistics]="allStatistics"
          >
          <span
            app-animating-count [yOffset]="-200"
            [count]="(+allStatistics?.stateServiceCount) + (+allStatistics?.centerServiceCount)"            [skips]="30"
            [interval]="40"
          ></span>
          {{ "pages.services" | translate }}</app-statistics-card
        >
      </ng-template>
    </div>

    <!-- Registration stats -->
    <div class="col-md-6 col-lg-3 statistics__col">
      <app-skeleton-loader
        *ngIf="isLoading; else registrationStats"
      ></app-skeleton-loader>

      <ng-template #registrationStats>
        <app-statistics-card
          [statsSVG]="((utilSerivce?.themeCheck | async) === 'dark' ? registrationCountDarkSVG : registrationCountSVG) | safeHTML"
          statsType="registrations"
          [allStatistics]="allStatistics"
          >{{ "stats.registrations" | translate }}</app-statistics-card
        >
      </ng-template>
    </div>

    <!-- Transaction stats -->
    <div class="col-md-6 col-lg-3 statistics__col">
      <app-skeleton-loader
        *ngIf="isLoading; else transactionStats"
      ></app-skeleton-loader>

      <ng-template #transactionStats>
        <app-statistics-card
          [statsSVG]="((utilSerivce.themeCheck | async) === 'dark' ? transactionCountDarkSVG : transactionCountSVG) | safeHTML"
          statsType="transactions"
          [allStatistics]="allStatistics"
          >{{ "stats.transactions" | translate }}</app-statistics-card
        >
      </ng-template>
    </div>
  </div>
</div>
